import React from 'react';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="font-manrope min-h-screen bg-gradient-to-b from-white to-[#3C59B2]/10">
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <a href="/" className="inline-block flex items-center space-x-2 text-gray-600 hover:text-gray-900 mb-8">
          <ArrowLeft className="w-4 h-4" />
          <span>Back to home</span>
        </a>

        <h1 className="font-manrope text-4xl font-bold text-gray-900 mb-8 animate-fade-in-up">Privacy Policy</h1>
        <p className="text-gray-600 mb-8">Last updated: {new Date().toLocaleDateString('fr-FR')}</p>

        <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <h2 className="font-manrope text-2xl font-bold text-gray-900 mb-4">1. Company Information</h2>
            <p className="text-gray-700">
              MON SERVICE IMMO<br />
              38 rue Victor Hugo<br />
              42300 Mably, France<br />
              Email: contact@3dtovideo.com
            </p>
          </section>

          <section>
            <h2 className="font-manrope text-2xl font-bold text-gray-900 mb-4">2. Data We Collect</h2>
            <p className="text-gray-700 mb-4">We collect the following personal information:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Full name</li>
              <li>Email address</li>
              <li>Company name (optional)</li>
              <li>Payment information (processed by Stripe)</li>
              <li>Usage data and analytics</li>
            </ul>
          </section>

          <section>
            <h2 className="font-manrope text-2xl font-bold text-gray-900 mb-4">3. How We Use Your Data</h2>
            <p className="text-gray-700 mb-4">We use your personal data to:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Provide and maintain our service</li>
              <li>Process your orders and payments</li>
              <li>Send service-related communications</li>
              <li>Improve our service and user experience</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="font-manrope text-2xl font-bold text-gray-900 mb-4">4. Legal Basis (GDPR)</h2>
            <p className="text-gray-700 mb-4">Under the GDPR, we process your data based on:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Contract performance:</strong> To provide our services</li>
              <li><strong>Legitimate interest:</strong> To improve our services</li>
              <li><strong>Consent:</strong> For marketing communications (opt-in)</li>
              <li><strong>Legal obligation:</strong> To comply with applicable laws</li>
            </ul>
          </section>

          <section>
            <h2 className="font-manrope text-2xl font-bold text-gray-900 mb-4">5. Data Sharing</h2>
            <p className="text-gray-700 mb-4">We may share your data with:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Payment processors:</strong> Stripe (for payment processing)</li>
              <li><strong>Service providers:</strong> Hosting, email, analytics</li>
              <li><strong>Legal authorities:</strong> When required by law</li>
            </ul>
            <p className="text-gray-700 mt-4">We do not sell your personal data to third parties.</p>
          </section>

          <section>
            <h2 className="font-manrope text-2xl font-bold text-gray-900 mb-4">6. Your Rights (GDPR)</h2>
            <p className="text-gray-700 mb-4">Under the GDPR, you have the right to:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Access:</strong> Request a copy of your personal data</li>
              <li><strong>Rectification:</strong> Correct inaccurate data</li>
              <li><strong>Erasure:</strong> Request deletion of your data ("right to be forgotten")</li>
              <li><strong>Restriction:</strong> Limit how we use your data</li>
              <li><strong>Portability:</strong> Receive your data in a structured format</li>
              <li><strong>Object:</strong> Oppose processing based on legitimate interest</li>
              <li><strong>Withdraw consent:</strong> For processing based on consent</li>
            </ul>
            <p className="text-gray-700 mt-4">
              To exercise these rights, contact us at: contact@3dtovideo.com
            </p>
          </section>

          <section>
            <h2 className="font-manrope text-2xl font-bold text-gray-900 mb-4">7. Data Retention</h2>
            <p className="text-gray-700">
              We retain your personal data only as long as necessary for the purposes outlined in this policy, 
              or as required by law. Account data is retained while your account is active and for up to 3 years 
              after account closure for legal and accounting purposes.
            </p>
          </section>

          <section>
            <h2 className="font-manrope text-2xl font-bold text-gray-900 mb-4">8. Data Security</h2>
            <p className="text-gray-700">
              We implement appropriate technical and organizational measures to protect your personal data against 
              unauthorized access, alteration, disclosure, or destruction. This includes SSL encryption, secure servers, 
              and access controls.
            </p>
          </section>

          <section>
            <h2 className="font-manrope text-2xl font-bold text-gray-900 mb-4">9. Cookies</h2>
            <p className="text-gray-700">
              We use essential cookies to ensure the proper functioning of our website. We may also use analytics 
              cookies to understand how visitors use our site. You can control cookies through your browser settings.
            </p>
          </section>

          <section>
            <h2 className="font-manrope text-2xl font-bold text-gray-900 mb-4">10. International Transfers</h2>
            <p className="text-gray-700">
              Your data may be transferred to and processed in countries outside the European Economic Area. 
              We ensure appropriate safeguards are in place through standard contractual clauses or Privacy Shield certification.
            </p>
          </section>

          <section>
            <h2 className="font-manrope text-2xl font-bold text-gray-900 mb-4">11. Children's Privacy</h2>
            <p className="text-gray-700">
              Our service is not intended for individuals under 18 years of age. We do not knowingly collect 
              personal data from minors.
            </p>
          </section>

          <section>
            <h2 className="font-manrope text-2xl font-bold text-gray-900 mb-4">12. Changes to This Policy</h2>
            <p className="text-gray-700">
              We may update this Privacy Policy from time to time. We will notify you of significant changes 
              by email or through a notice on our website.
            </p>
          </section>

          <section>
            <h2 className="font-manrope text-2xl font-bold text-gray-900 mb-4">13. Contact & Complaints</h2>
            <p className="text-gray-700">
              For questions about this Privacy Policy or to exercise your rights, contact us at:<br />
              <strong>Email:</strong> contact@3dtovideo.com<br />
              <strong>Address:</strong> 38 rue Victor Hugo, 42300 Mably, France
            </p>
            <p className="text-gray-700 mt-4">
              You also have the right to lodge a complaint with the French data protection authority (CNIL) at: 
              <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#3C59B2] hover:underline inline-block"> www.cnil.fr</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;